import React, { useRef } from "react";
import styled, { withTheme } from "styled-components";

const Container = styled.div`
  border-radius: 17px;
  background-color: ${(props) =>
    props.$backgroundColor ?? props.theme?.lightPurpleOpacity};
  padding: 4px 8px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
`;

const StyledText = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.$textColor ?? props.theme?.violetEggplant};
  cursor: ${(props) => (props.$clickable ? "pointer" : "")};
`;

const StyledRemoveIcon = styled("i")`
  color: ${(props) => props.$color ?? props.theme?.violetEggplant};
  font-size: 14px;
  margin-left: 9px;
  cursor: pointer;
`;

const FilterTag = (props) => {
  const { filterTag, backgroundColor, textColor, onRemove, onClick } = props;

  const filterTagRef = useRef(null);

  return (
    <Container
      $backgroundColor={backgroundColor}
      $borderColor={textColor}
      ref={filterTagRef}
    >
      <StyledText
        data-testid={props["data-testid"] || "filter-tag"}
        $textColor={textColor}
        $clickable={onClick}
        onClick={(e) => onClick(filterTag, e.target)}
      >
        {filterTag.title && <strong>{filterTag.title}</strong>} {filterTag.text}
      </StyledText>
      <StyledRemoveIcon
        onClick={() => onRemove(filterTag)}
        className="fas fa-times noprint"
        aria-hidden="true"
        data-testid={`${props["data-testid"] || "filter-tag"}-remove-button`}
        $color={textColor}
      />
    </Container>
  );
};

export default withTheme(FilterTag);
